module.exports = __webpack_public_path__ + "components/flag/static/square/mh-35790273c9d8d967ebb38f9869f93412.svg";